<template>
  <div class="animated fadeIn list-of-jurnal">
    <b-card>
      <div slot="header">Reclass - Project/Work in Progress 
        <div class="card-header-actions">
          <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
          <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><label>Jurnal Number</label></b-input-group-prepend>
              <b-form-input v-if="(manualjurnal==1)" v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
              <b-form-input v-else v-model="model.nomor" :state="!$v.model.nomor.$error"></b-form-input> 
              <b-input-group-append><span class="ml-2 pt-2 mr-1">Jurnal Date</span></b-input-group-append>
              <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>                                        
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group >
              <!-- <b-input-group-prepend><label>Reference</label></b-input-group-prepend>
              <b-form-input v-model="model.reff" ></b-form-input> 
              <b-input-group-append><span class="ml-2 pt-2 mr-1">Group/source</span></b-input-group-append> -->
              <b-input-group-prepend><label>Group Jurnal</label></b-input-group-prepend>
              <b-form-select v-model="model.kodejurnal" :plain="true" :options="jurnalGroup" :state="!$v.model.kodejurnal.$error"></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined responsive hover
        style="font-size:smaller;" 
        :items="ayatJurnal.items"
        :fields="tblFields"
      >
        <template v-slot:cell(index)="data">
          {{data.index + 1}}
        </template>
        <template v-slot:cell(kodeacc)="data">
          <span v-if=(data.item.kodeacc)>
            {{data.item.kodeacc}} | {{data.item.namaacc}}
          </span>
        </template>
        <template v-slot:cell(umasuk)="data">
          <span v-if=(data.item.kodeacc)>
            {{data.item.umasuk|numFormat('0,0.00')}}
          </span>
        </template>
        <template v-slot:cell(ukeluar)="data">
          <span v-if=(data.item.kodeacc)>
            {{data.item.ukeluar|numFormat('0,0.00')}}
          </span>
        </template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="editAyatJurnal(data.item,data.toggleDetails)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click="delAyatJurnal(data.index)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
        <template v-slot:row-details="row">
          <b-card no-body class="row-details-form">
            <b-row class="mt-2">
              <b-col class="pr-4" cols="6">
                  <b-input-group >
                      <b-input-group-prepend><label>GL Account #</label></b-input-group-prepend>
                      <b-form-input  v-model="ayatJurnalObj.kodeacc"  :state="!$v.ayatJurnalObj.kodeacc.$error"></b-form-input>
                      <b-form-input readonly v-model="ayatJurnalObj.namaacc" style="width:50% !important;" :state="!$v.ayatJurnalObj.kodeacc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount" :disabled="ayatJurnalObj.kunciAyat">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-textarea :rows="2" :max-rows="3" v-model="ayatJurnalObj.uraian" :state="!$v.ayatJurnalObj.uraian.$error" ></b-form-textarea>
                  </b-input-group>

                  <b-input-group >
                      <b-input-group-prepend><label>Amount Debit</label></b-input-group-prepend>
                      <my-number class="form-control text-right" v-model="ayatJurnalObj.umasuk" :precision="2" @change.native="mutasiDb" @keydown.enter.native="handleEnterAmt" :disabled="ayatJurnalObj.kunciAyat"></my-number>
                      <b-input-group-append class="ml-2">
                      <b-btn text="Button" variant="warning" @click="mutasiBalik()" >
                          <i class="fa fa-exchange"></i>
                      </b-btn>
                      </b-input-group-append>
                    <b-input-group-append><span class="ml-2 pt-2 mr-1">Amount Credit</span></b-input-group-append>
                      <my-number class="form-control text-right" separator="," v-model="ayatJurnalObj.ukeluar" :precision="2" @change.native="mutasiCr" @keydown.enter.native="handleEnterAmt" :disabled="ayatJurnalObj.kunciAyat"></my-number>
                  </b-input-group>
                  <b-row >
                    <b-col class="pr-4" cols="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Reference</label></b-input-group-prepend>
                            <b-form-input v-model="ayatJurnalObj.reff" ></b-form-input> 
                        </b-input-group>
                    </b-col>
                  </b-row>
              </b-col>
              <b-col class="pr-4" cols="6">
                  <v-dim :model="ayatJurnalObj"></v-dim>                  
                  <b-input-group >
                      <b-input-group-prepend><label>PIP/WIP subAccount</label></b-input-group-prepend>
                      <b-form-input  v-model="ayatJurnalObj.pip_code"  :state="!$v.ayatJurnalObj.pip_code.$error"></b-form-input>
                      <b-form-input readonly v-model="ayatJurnalObj.pip_name" style="width:50% !important;" :state="!$v.ayatJurnalObj.pip_code.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuPipAccountShow=true" id="btnPipAccount" :disabled="ayatJurnalObj.kunciAyat">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
            </b-row>
            <b-row class="justify-content-center mb-2">
                  <div style="width:400px;">
                      <b-input-group >
                          <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                          <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                          <b-input-group-append>
                              <b-button class="btn btn-success mr-1" @click="saveAyatJurnal()">Update</b-button>
                          </b-input-group-append>
                          <b-input-group-append>
                              <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                          </b-input-group-append>
                      </b-input-group>
                  </div>

            </b-row>
          </b-card>
        </template>                        
      <template slot="bottom-row" slot-scope="data">
        <td colspan="3">          
          <b-row class="m-0" no-gutters="">
            <div class="mt-1">Total {{totalRow}} lines </div>
            <b-button size="sm" class="ml-1" @click="addAyatJurnal" >Add Journal Line</b-button>
          </b-row>
        </td>
        <td class="tebal total">TOTAL ({{uanguser}})</td>
        <td class="tebal total">{{totalDb|numFormat('0,0.00')}}</td>
        <td class="tebal total">{{totalCr|numFormat('0,0.00')}}</td>
        <td :colspan="(data.columns-5)"> </td>
      </template>
      </b-table>
      <b-row class="justify-content-center mt-2">        
          <!-- <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
          <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button> -->
          <div style="width:450px;">
              <b-input-group >
                  <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                  <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                  <b-input-group-append>
                      <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  </b-input-group-append>
                  <b-input-group-append>
                      <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                  </b-input-group-append>
              </b-input-group>
          </div>
      </b-row>
    </b-card>

        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuPipAccountShow" size="lg" :hide-footer="true" title="(PIP) Project/Work In progress" :centered="true" >
            <lku-pipaccount @click="onSelectLkuPipAccount" isactive="1"></lku-pipaccount>
        </b-modal>        

  </div>
</template>

<style lang="scss">
    .list-of-jurnal {
      table {
        td.tebal {
            font-weight: bold;
        }
            
        td.total {
            border-top: 2px solid #000 !important;
            background: #e6e6e6 !important;
            text-align:right;
        }

      }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 130px !important;
                  margin-right:5px;
              }
          }
      }

    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuCoa from "../lookup/lkuCoa";
import lkuPipaccount from "../lookup/lkuPipaccount";
import buku from "../../apis/buku";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, vDim, lkuCoa, lkuPipaccount},
  mixins: [validationMixin],
  validations: {
    model: {
        nomor: {required : (function() {
            if ((this.manualjurnal || 0) == 1) {
                return true;
            } else if ((this.model.nomor || '')==''){
                return false;
            } else return true;
        })},
        tanggal: { required },
        kodejurnal: { required },
    },
    ayatJurnalObj: {
        kodeacc: { required },
        uraian: { required },
        pip_code: {required : (function() {
                if (this.pipAccount==false) {
                    return true;
                } else if ((this.ayatJurnalObj.pip_code || '')=='') {
                    return false;
                } else return true;
            })},
    }
  }, 
  data() {
    return {
      saveEnabled: true,
      horizontal: true,
      lkuCoaShow:false,
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      coa:[],
      model:{kodejurnal:'-', nomor:'', tanggal:this.$store.state.user.akhirbln, numprefix:''},
      pipTrx:{},
      manualjurnal:0,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      totalDb:0,
      totalCr:0,
      totalRow:0,
      fsubkode1: '', 
      kodefield1: '', 
      subkode1: '', 
      fsubkode2: '',
      kodefield2: '', 
      subkode2:'',  
      ayatJurnal: {
        items: [],
        selected:{},
      },
      ayatJurnalObj: {kodeacc:'',namaacc:'', glAccount:'', uraian:'', umasuk:0, ukeluar:0, pip_code:'', pip_name:'', kunciAyat: false},
      pipAccount:false, pipAccounts:[], lkuPipAccountShow:false,    
      jurnalGroup:[{ value: '-', text: '-- Others -' }, 
              { value: 'APINV', text: 'AP Invoice' },
              { value: 'ARINV', text: 'AR Invoice' },
              { value: 'ADVSTTL', text: 'Advance Settlement' },
              { value: 'EXPN', text: 'Expense Reimbursment' },
              { value: 'FIXEDASSET', text: 'Fixed Asset Depreciation' },
              { value: 'BANKOUT', text: 'Bank/Cash Payment' },
              { value: 'BANKIN', text: 'Bank/Cash Receipt' },
          ]      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    uanguser(){
      return this.$store.state.user.matauang;
    },
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
            thStyle: "width:20px",
          },
          {
            key: "kodeacc",
            label: "Account",
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "reff",
            label: "Reff Doc.#",
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            // thStyle: "width:150px",
            label: dims[i].text
          },)
        }

        fields.push({
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          });
      return fields;
    },
    invalidAyatJurnal() {
      this.$v.ayatJurnalObj.$touch();
      return this.$v.ayatJurnalObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch:{
      "model.kodejurnal": function(newval) {
          const newKodeJurnal = this.jurnalGroup.find(d => d.value === newval);
          if (newKodeJurnal) {
            this.manualjurnal = newKodeJurnal.manualjurnal || 0;
            this.model.numprefix = newKodeJurnal.numprefix || '';
          }
      },
    'ayatJurnalObj.kodeacc': function(newval) {
      setTimeout(() => {
          if ((this.ayatJurnalObj.kodeacc === newval) && (newval)) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                this.ayatJurnalObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.ayatJurnalObj.kodeacc = _selected.kodeacc;
                this.ayatJurnalObj.namaacc = _selected.namaacc;
                this.$forceUpdate();  
                this.dimension.forEach((dim) => {
                    if (_selected[dim.value]) {
                        this.ayatJurnalObj[dim.value] = _selected[dim.value];
                        this.ayatJurnalObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                        // this.ayatJurnalObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                        this.ayatJurnalObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                    }
                });      
            } else {
                this.ayatJurnalObj.kodeacc='';
                this.ayatJurnalObj.namaacc = '';
            }
          }
      }, 1000);
     },

  },  
  created: async function (){
     const { user } = this.$store.state;
      if ((this.$route.params.pipkey))  {
          toastr.info('Loading Journal Detail, please wait')
          try {
            this.$route.params.tanggal= moment().format('YYYY-MM-DD');
            const [kodeList,pipAccounts] = await Promise.all([buku.kodejurnal(),buku.pipAccount()]) ;
            if ((kodeList) && (kodeList.length>0)) {
              this.jurnalGroup = kodeList;
            }
            this.pipAccounts=pipAccounts
            const pipTrx = this.$route.params;
            this.model.tanggal = moment().format('YYYY-MM-DD');
            this.model.nomor = '';
            if (this.model.tanggal<user.tglaktif) {
              this.model.tanggal = user.tglaktif;
            }

            this.model.tgllama = '';
            this.model.nomorlama = '';
            this.model.kodejurnal = '';
            // this.model.reff = row.reff;
            // this.fsubkode1 = row.fsubkode1;
            // this.kodefield1 = row.kodefield1;
            // this.subkode1 = row.subkode1;
            // this.fsubkode2 = row.fsubkode2;
            // this.kodefield2 = row.kodefield2;
            // this.subkode2 = row.subkode2;       

            this.ayatJurnal.items.push(
              { kodeacc : pipTrx.pipkodeacc,
                namaacc : pipTrx.pipnamaacc,
                uraian: `RECLASS PIP - ${pipTrx.pip_name}`,
                pip_code: pipTrx.pip_code,
                pip_name: pipTrx.pip_name,
                umasuk:0,
                ukeluar: pipTrx.saldoDB-pipTrx.saldoCR,
                kunciAyat: true
              }
            );
            this.calcTotal();
            this.tahun=0;
            this.tanggalBerubah();
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [kodeList,coa, pipAccounts] = await Promise.all([buku.kodejurnal(), buku.getcoa({ tahun: this.tahun}),buku.pipAccount()]);
        if ((kodeList) && (kodeList.length>0)) {
          this.jurnalGroup = kodeList;
        }
        this.coa=coa;
        this.pipAccounts=pipAccounts
      }
  },
  methods: {
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    tanggalBerubah: function(){
            const newVal=moment(this.model.tanggal).format('YYYY');
            if ( this.tahun != newVal) {
                this.tahun=newVal ;
                buku.getcoa({ tahun: this.tahun}).then(result => {
                        this.coa = result;
                        if  (this.coa.length==0) {
                            this.getCoa();
                        }                        
                    })
                    .catch(err => {
                        console.log('get COA -> ', err);
                    });
            } else if  (this.coa.length==0) {
                this.getCoa();
            }
    },
    getCoa: function(){
        this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
        buku.getcoa({ tahun: this.tahun}).then(result => {
                this.coa = result;
            })
            .catch(err => {
                console.log('get COA -> ', err);
            });
    },     
    closeAyatJurnal: function(){
        const opened= this.ayatJurnal.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addAyatJurnal : function () {
      this.closeAyatJurnal();
        const uraian= this.ayatJurnalObj.uraian || ''; 
        const reff= this.ayatJurnalObj.reff || ''; 
        const obj={_showDetails:true};
        this.ayatJurnal.selected = obj;
        for (var key in this.ayatJurnalObj) {
            this.ayatJurnalObj[key] = '';
        }
        this.ayatJurnalObj.kunciAyat = false;
        this.ayatJurnalObj.uraian = uraian;
        this.ayatJurnalObj.reff = reff;
        this.ayatJurnal.items.push(obj);
        this.ayatJurnal.total=this.ayatJurnal.items.length;
        this.inputLineBerlanjut=1;
    },
    editAyatJurnal : function (obj,callback) {
      this.closeAyatJurnal();
        console.log('Obj edited: ', obj);
        this.ayatJurnal.selected = obj;
        for (var key in this.ayatJurnalObj) {
            this.ayatJurnalObj[key] = '';
        }
        this.ayatJurnalObj.kunciAyat = false;
        for (var key in obj) {
            this.ayatJurnalObj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.ayatJurnalObj[dim.value] = obj[dim.value];
                this.ayatJurnalObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.ayatJurnalObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.inputLineBerlanjut=0;
        callback();
    },
    delAyatJurnal: function (index) {
      if (this.ayatJurnalObj.kunciAyat) {
            toastr.error(`This Line can't be deleted , it is PIP account`);
      } else {
        if (index > -1) {
        this.ayatJurnal.items.splice(index, 1);
        }
        this.ayatJurnal.total=this.ayatJurnal.items.length;
        this.calcTotal();
      }
    },
    saveAyatJurnal: async function (callback) {
        this.ayatJurnalObj.umasuk = this.ayatJurnalObj.umasuk || 0;
        this.ayatJurnalObj.ukeluar = this.ayatJurnalObj.ukeluar || 0;
        if ((this.invalidAyatJurnal) || ((this.ayatJurnalObj.umasuk===0) && (this.ayatJurnalObj.ukeluar==0))) {
            toastr.error('Please fill the form correctly.');
       } else {
            let datadim=this.ayatJurnalObj;
            datadim.TableName = 'buku';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.ayatJurnalObj) {
                        this.ayatJurnal.selected[key] = this.ayatJurnalObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.ayatJurnal.selected[dim.value] = datadim[dim.value];
                            this.ayatJurnal.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.ayatJurnal.items.sort(
                          function(a, b) {          
                              if (parseFloat(a.umasuk) === parseFloat(b.umasuk)) {
                                // ukeluar is only important when umasuk are the same
                                return parseFloat(b.ukeluar) - parseFloat(b.ukeluar);
                              }
                              return parseFloat(b.umasuk) - parseFloat(a.umasuk);
                          });
                    this.calcTotal();
                    const dimSama = this.ayatJurnal.items.filter(a=> ((a.TableKey==datadim.TableKey) && (a.bukukey!==datadim.bukukey)));
                    if (dimSama) {
                        dimSama.forEach((ayat)=>{
                            this.dimension.forEach((dim) => {
                                if (datadim[dim.value]) {
                                    ayat[dim.value] = datadim[dim.value];
                                    ayat[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                                }
                            });
                        });
                    }

                    this.ayatJurnal.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                       this.addAyatJurnal();
                        this.$v.ayatJurnalObj.$reset();                        
                    }
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error));                
            }
        }
    },
    onSelectLkuCoa(_selected) {
        this.ayatJurnalObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.ayatJurnalObj.kodeacc = _selected.kodeacc;
        this.ayatJurnalObj.namaacc = _selected.namaacc;
        this.dimension.forEach((dim) => {
            if (_selected[dim.value]) {
                this.ayatJurnalObj[dim.value] = _selected[dim.value];
                this.ayatJurnalObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                this.ayatJurnalObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                // this.ayatJurnalObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
            }
        });        
        this.lkuCoaShow=false;
            const ketemu = this.pipAccounts.find(ac => ac.kodeacc==this.apLinesObj.kodeacc);
            this.pipAccount= (ketemu);
            console.log ('pipAccount : ',this.pipAccount);
            if (this.pipAccount){
                toastr.info('Prepaid Expense, should be Amortized');
            }

    },
    onSelectLkuPipAccount(_selected) {
        this.ayatJurnalObj.pip_code = _selected.pip_code;
        this.ayatJurnalObj.pip_name = _selected.pip_name;
        this.lkuPipAccountShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            

        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (Math.abs(this.totalDb-this.totalCr)>0.5) {
            toastr.error('Amount DEBIT & CREDIT not Balance ', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
              let tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
              let lines = this.ayatJurnal.items.reduce((newArr, item) => {
                  if ((item.kodeacc || '') != '')
                  {
                      item.tanggal = tanggal;
                      item.nomor = this.model.nomor;
                      item.kodejurnal = this.model.kodejurnal;
                      if (!(item.fsubkode2)) {
                        // item.fsubkode1 = this.fsubkode1;
                        // item.kodefield1 = this.kodefield1;
                        // item.subkode1 = this.subkode1;
                        item.fsubkode2 = item.fsubkode2 || this.fsubkode2;
                        item.kodefield2 = item.kodefield2 || this.kodefield2;
                        item.subkode2 = item.subkode2 || this.subkode2;       
                      }
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              let row={nomor:this.model.nomorlama, 
                       tanggal:this.model.tgllama, 
                       manualjurnal: this.manualjurnal, 
                       kodejurnal: this.model.kodejurnal, 
                       numprefix: this.model.numprefix, 
                       lines:lines};

              const hasil= await buku.insert(row);
              toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Jurnal",10000);

              if (this.inputBerlanjut==0){
                  this.close();
              } else {
                  this.saveEnabled=true;            
                  // const kodejurnal = this.model.kodejurnal;
                  // for (var key in this.model) {
                  //     this.model[key] = '';
                  // }
                  // // this.model.kodejurnal = kodejurnal;
                  this.model.nomor='';
                  this.model.nomorlama=''; 
                  this.model.tgllama=''; 
                  this.ayatJurnal.items=[];
                  this.calcTotal();
                  this.ayatJurnal.umasuk = 0;
                  this.ayatJurnal.ukeluar = 0;
                  this.$v.model.$reset();                        
              }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }
        }
    },
    calcTotal: function () {
        let totalDb =  0;
        let totalCr =  0;
        // let totalRow =  0;
        this.ayatJurnal.items.forEach((trx)=> {
            if (trx.kodeacc)
            {
              totalDb = totalDb + parseFloat(trx.umasuk || 0);
              totalCr = totalCr + parseFloat(trx.ukeluar || 0);
            }
        });
        this.totalDb =  totalDb;
        this.totalCr =  totalCr;
        this.totalRow =  this.ayatJurnal.items.length;
    },
    mutasiDb: function () {
        this.ayatJurnalObj.ukeluar =  0;
    },
    handleEnterAmt: function (e) {
      // handle CTRL+ENTER , mengisi otomatis DB atau CREDIT, senilai selisih
      if (e.ctrlKey) {
        if ( this.totalDb>this.totalCr) {
            this.ayatJurnalObj.umasuk =  0;
            this.ayatJurnalObj.ukeluar =  this.totalDb-this.totalCr;   
        } else {
            this.ayatJurnalObj.umasuk =  this.totalCr-this.totalDb;     
            this.ayatJurnalObj.ukeluar =  0;
        } 
      }  
    },
    mutasiCr: function () {
        this.ayatJurnalObj.umasuk =  0;
    },
    mutasiBalik: function () {
        let temp = parseFloat(this.ayatJurnalObj.umasuk);
        this.ayatJurnalObj.umasuk =  parseFloat(this.ayatJurnalObj.ukeluar);
        this.ayatJurnalObj.ukeluar = temp;
        this.$forceUpdate();
    },
    close(){
        router.push({name:'accounting.pip'});
    },    
  }
};
</script>
